const ITEMS = [
    "Lavado Premium",
    "Detailing",
    "Pulido de Faros",
    "Ozono",
    "Tapicería",
    "Anti-lluvia",
    "Motos",
    "Pack Completo",
];

export const Marquee = () => (
    <div
        data-testid="marquee-strip"
        aria-hidden="true"
        className="overflow-hidden border-y border-gold/15 bg-ink py-5"
    >
        <div className="marquee-track flex w-max items-center gap-12 whitespace-nowrap">
            {[...ITEMS, ...ITEMS, ...ITEMS].map((item, i) => (
                <span key={i} className="flex items-center gap-12">
                    <span className="font-display text-sm font-bold uppercase tracking-[0.35em] text-white/25">
                        {item}
                    </span>
                    <span className="h-1.5 w-1.5 rotate-45 bg-gold/60" />
                </span>
            ))}
        </div>
    </div>
);
